<router-outlet></router-outlet>
<app-loader></app-loader>
@if (contentType === 'show') {
<app-upload-progress-loader></app-upload-progress-loader>
}
